import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "@/views/HomeView";
// news
import NewsListView from "@/views/news/List.vue";
import NewsDetailView from "@/views/news/detail.vue"

// activity
import ActivityListView from "@/views/activity/List.vue";
import ActivityDetailView from "@/views/activity/detail.vue"

// memeber
import MemberListView from "@/views/member/List.vue";
import MemberDetailView from "@/views/member/detail.vue";

// job
import JobListView from "@/views/job/List.vue";
import jobDetailView from "@/views/job/detail.vue";

// SocialService
import SocialServiceListView from "@/views/socialService/List.vue";
import SocialServiceDetailView from "@/views/socialService/detail.vue"

// platform
import PlatformListView from "@/views/platform/List.vue";
import platformDetailView from "@/views/platform/detail.vue"

// about
import AboutView from "@/views/aboutUs/AboutView.vue";

// project
import Project from "@/views/project/Project.vue"

// paper
import Paper from "@/views/paper/Paper.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView
  },
  {
    path: "/news/list",
    name: "news",
    component: NewsListView
  },
  {
    path: "/news/detail",
    name: "newsDetail",
    component: NewsDetailView
  },
  {
    path: "/activity/list",
    name: "activity",
    component: ActivityListView
  },
  {
    path: "/activity/detail",
    name: "activityDeatil",
    component: ActivityDetailView
  },
  {
    path: "/member/list",
    name: "member",
    component: MemberListView
  },
  {
    path: "/member/detail",
    name: "memberDetail",
    component: MemberDetailView
  },
  {
    path: "/job/list",
    name: "job",
    component: JobListView
  },
  {
    path: "/job/list",
    name: "jobDetail",
    component: jobDetailView
  },
  {
    path: "/social_services/list",
    name: "social_services",
    component: SocialServiceListView
  },
  {
    path: "/social_services/detail",
    name: "social_services_detail",
    component: SocialServiceDetailView
  },
  {
    path: "/platform/list",
    name: "platform",
    component: PlatformListView
  },
  {
    path: "/platform/detail",
    name: "platformDetail",
    component: platformDetailView
  },
  {
    path: "/about",
    name: "about",
    component: AboutView
  },
  {
    path: "/project",
    name: "project",
    component: Project
  },
  {
    path: "/paper",
    name: "paper",
    component: Paper
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
